'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exec;

var _httpplease = require('httpplease');

var _httpplease2 = _interopRequireDefault(_httpplease);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function exec(ns, json, callback) {

  var query = _queryString2.default.stringify(json);
  var baseUrl = 'https://slack.com/api/';
  var url = '' + baseUrl + ns + '?' + query;
  var rateLimit = 'You are sending too many requests. Please relax.';

  _httpplease2.default.get(url, function (err, res) {
    if (err) {
      // if request failed bubble the error
      callback(err);
    } else if (res.body.error) {
      // if Slack returns an error bubble the error
      callback(Error(res.body.error));
    } else if (typeof res.body === 'string' && res.body.includes(rateLimit)) {
      // sometimes you need to chill out
      callback(Error('rate_limit'));
    } else {
      // success! clean up the response
      var _json = JSON.parse(res.body);
      if (_json.ok) {
        delete _json.ok;
        callback(null, _json);
      } else {
        callback(Error(_json.error));
      }
    }
  });
  /// eom
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/slack/methods/_exec-browser.js
// module id = 2
// module chunks = 0